import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
// -
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import ManagerSensorsPreview from "./models/preview/ManagerSensorsPreview";

const PreviewSensors = ({show, item}) => {
    // const { t } = useTranslation("forms")
    const {t: tC} = useCustomTranslation(translations);
    const [formData, setFormData] = useState({...item});

    useEffect(() => {
        setFormData({...item});
    }, [item]);

    return (
        <div
            className={`col preview-row ${show ? "" : "d-none"}`}
            style={{width: "400px", maxWidth: "400px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card border-start" style={{width: "400px"}}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon
                                    icon="wifi"
                                    className="fa-rotate-180"
                                />
                            </div>
                            <div className="preview-title">
                                <label>{tC("sensorconfig")}</label>
                                <div>{formData.name}</div>
                            </div>
                        </div>
                        <div className="p-2">
                            <div className="preview-item">
                                <label>{tC("name")}</label>
                                <div className="preview-input">{formData.name}</div>
                            </div>
                            <div className="preview-item">
                                <label>{tC("model")}</label>
                                <div className="preview-input">{formData.model}</div>
                            </div>
                            <ManagerSensorsPreview item={formData} t={tC} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewSensors;
